import PropTypes from "prop-types";
import { AvatarsButton } from "./AvatarsButton";

export const EventSpaceActions = ({ space }) => <AvatarsButton space={space} />;

EventSpaceActions.propTypes = {
  space: PropTypes.object.isRequired,
};
